module.exports = __webpack_public_path__ + "img/add.ad882c1a.svg";